function createVideo({
  isPreload,
  sectionSelector,
  videoContainerSelector,
  videoSelector,
  posterSelector,
  crossDeviceSrc,
  desktopSrc,
  mobileSrc,
  playBtnSelector,
  muteBtnSelector,
  slideshow,
}) {
  let isMobile = window.innerWidth < 720 ? true : false;
  let videoPoster = null;
  let video = null;
  let videoCurrentTime = 0;
  let videoHasError = null;
  let playBtn = null;

  function setPlayBtn() {
    playBtn = document.querySelector(playBtnSelector);
    if (!playBtn) {
      console.warn("play button not found");
      return;
    }

    function disableBtn() {
      syncVideoPlayingStatus();
      playBtn.classList.add("disabled");
      playBtn.disabled = true;
    }

    function enableBtn() {
      syncVideoPlayingStatus();
      playBtn.classList.remove("disabled");
      playBtn.disabled = false;
    }

    function togglePlay() {
      if (video.paused) {
        playBtn.classList.add("playing");
        playBtn.setAttribute("aria-label", "Pause (Enter/Spacer)");
        video.play();
      } else {
        playBtn.classList.remove("playing");
        playBtn.setAttribute("aria-label", "Play (Enter/Spacer)");
        video.pause();

        if (slideshow) {
          slideshow.setToPause();
        }
      }
    }

    function handleClick() {
      playBtn.addEventListener("click", (event) => {
        event.preventDefault();
        togglePlay();
      });
    }

    function handleKeyPress() {
      playBtn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          togglePlay();
        }
      });
    }

    function syncVideoPlayingStatus() {
      function togglePlay() {
        if (video.paused) {
          playBtn.classList.remove("playing");
        } else {
          playBtn.classList.add("playing");
        }
      }

      if (video.networkState === 2) {
        if (video.readyState > 2) {
          video.addEventListener("canplaythrough", () => {
            togglePlay();
          });
        } else {
          video.addEventListener("loadeddata", () => {
            video.autoplay ? video.addEventListener("play", togglePlay, { once: true }) : togglePlay();
          });
        }
      } else {
        togglePlay();
        if (video.paused) {
          video.addEventListener("play", togglePlay, { once: true });
        }
      }
    }

    function init() {
      syncVideoPlayingStatus();
      handleClick();
      handleKeyPress();
    }

    return {
      init,
      disableBtn,
      enableBtn,
      syncVideoPlayingStatus,
    };
  }

  function setPoster() {
    function showPoster() {
      videoPoster.classList.remove("hidden");
    }

    function hidePoster() {
      videoPoster.classList.add("hidden");
    }

    return {
      showPoster,
      hidePoster,
    };
  }

  function getVideoElements() {
    video = document.querySelector(videoSelector);
    videoPoster = document.querySelector(posterSelector);
  }

  function setVideoSrc() {
    if (!video) return;

    if (crossDeviceSrc) {
      video.src = crossDeviceSrc;
      return;
    }

    if (isMobile) {
      video.src = mobileSrc;
    } else {
      video.src = desktopSrc;
    }
  }

  function loadVideo() {
    if (!video) return;

    return new Promise((resolve, reject) => {
      function cleanup() {
        video.removeEventListener("error", onError);
        video.removeEventListener("canplay", onCanPlay);
      }

      function onCanPlay() {
        if (video.autoplay) video.play();
        setPoster().hidePoster();
        setPlayBtn().init();
        cleanup();
        resolve();
      }

      function onError(error) {
        videoHasError = true;
        setPoster().showPoster();
        setPlayBtn().init();
        setPlayBtn().disableBtn();
        cleanup();
        reject(error);
      }

      video.addEventListener("canplay", onCanPlay);
      video.addEventListener("error", onError);

      video.load();
    });
  }

  function reloadVideo() {
    new Promise((resolve, reject) => {
      function cleanup() {
        video.removeEventListener("error", onError);
        video.removeEventListener("canplay", onCanPlay);
      }

      function onCanPlay() {
        video.currentTime = videoCurrentTime;

        if (playBtn.classList.contains("playing")) {
          video.play();
        } else if (videoHasError && video.autoplay) {
          video.play();
        } else {
          video.pause();
        }

        if (videoHasError) {
          videoHasError = false;
          setPoster().hidePoster();
          setPlayBtn().enableBtn();
        }

        cleanup();
        resolve();
      }

      function onError() {
        videoHasError = true;
        setPoster().showPoster();
        setPlayBtn().disableBtn();
        cleanup();
        reject();
      }

      video.addEventListener("canplay", onCanPlay);
      video.addEventListener("error", onError);

      video.load();
    });
  }

  function handleResize() {
    window.addEventListener("resize", () => {
      if (window.innerWidth < 720 && isMobile) return;
      if (window.innerWidth >= 720 && !isMobile) return;
      isMobile = window.innerWidth < 720 ? true : false;
      videoCurrentTime = video.currentTime;
      setVideoSrc();
      reloadVideo();
    });
  }

  function handlePreloadVideo() {
    function handleVideoError() {
      videoHasError = video.readyState === 0;
      if (videoHasError) {
        setPlayBtn().disableBtn();
      } else {
        setPoster().hidePoster();
      }
    }

    if (video.networkState === 2) {
      video.addEventListener("loadeddata", handleVideoError);
    } else {
      handleVideoError();
    }
  }

  function playVideo() {
    video.play();
    setPlayBtn().syncVideoPlayingStatus();
  }

  // Entry
  function init() {
    getVideoElements();
    if (isPreload) {
      handlePreloadVideo();
      if (!crossDeviceSrc) handleResize();
      setPlayBtn().init();
    } else {
      setVideoSrc();
      try {
        loadVideo();
      } catch (e) {
        console.log(e);
      }
      if (!crossDeviceSrc) handleResize();
    }
  }

  return {
    init,
    playVideo,
  };
}

module.exports = createVideo;
